<!-- src/App.vue -->

<template>
  <main>
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row justify-content-center mt-3 m-2">
        <div class="col-12 col-lg-8 dark-gray-box-1 py-2 mb-3 mb-lg-0">
        <h6 class="subTitleFont">Featured Pages</h6>
        <HomePagePart1ArtistsNews id="lordxv" />
        </div>
        <div class="col-12 col-lg-3 dark-gray-box-1 py-2 ms-lg-3">
          <h6 class="subTitleFont">News</h6>
          <p class="p-2 textlightgray">Check back later!</p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  //import imageBlock from './../../components/imageBlock.vue';
  import HomePagePart1ArtistsNews from '@/HomePagePart1ArtistsNews.vue';
  import 'animate.css';
  
  export default {
    name: 'HomePage',
    components: {
    //imageBlock,
    HomePagePart1ArtistsNews,
   
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        showB1:  false,
        showB2:  false,
        showB3:  false,
        showB4:  false,
        showB5:  false,
        isClassAdded: false,
        apiUrl: '',
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      },
      addClass(event) {
      // Prevent the default navigation
      event.preventDefault();

      // Add the class to trigger the animation
      this.isClassAdded = true;

      // Wait for the animation to complete before navigating
      // Assuming the animation duration is 1 second (1000 milliseconds)
      setTimeout(() => {
        window.location.href = this.apiUrl;
      }, 1000); // Adjust the timeout duration based on your actual animation duration
    },
    },
    mounted(){
      document.title = "Sinless Project Home";
    },
    created() {
      const userAgent = navigator.userAgent;
      if (process.env.NODE_ENV === 'production' || (/Mobi|Android/i.test(userAgent))) {
        this.apiUrl = 'https://dev.sinlessproject.com/subTitleFont';
      } else {
        this.apiUrl = 'http://localhost:8080/subTitleFont';
      }

  },
  }

</script>